import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { useActionData, useSubmit } from 'react-router';

import Button from 'client/components/aria/Button/Button';

import geometry from 'client/utils/format/ol/geometry';
import { jsonToFormData } from 'client/utils/helpers/Workpack/Workpack';
import { CREATE_WORKPACK_PAGE } from 'client/utils/routes/routeConstants';
import { selectDrawType } from 'client/store/drawSlice/drawSlice';
import { LINE } from 'client/utils/constants/symbolName';
import styles from './ContinueWorkpackButton.module.scss';
import { useHover } from 'react-aria';
import { selectMapMode } from 'client/store/mapSlice/mapSlice';
import Tooltip from 'client/components/aria/Tooltip/Tooltip';

const ContinueWorkpackButton = () => {
    const source = useSelector(state => state?.aoi?.source);

    const drawType = useSelector(selectDrawType);
    const [showTooltip, setShowTooltip] = useState(false);
    const { hoverProps } = useHover({
        onHoverStart: () => setShowTooltip(true),
        onHoverEnd: () => setShowTooltip(false)
    });
    const mapMode = useSelector(selectMapMode);

    const draftWorkpackFromStore = useSelector(state => state?.workpacks?.draftWorkpack);
    const { workpack } = useActionData() || {};
    const [draftWorkpack, setDraftWorkpack] = useState(() => {
        if (workpack) {
            return workpack;
        } else {
            return draftWorkpackFromStore || {};
        }
    });
    const submit = useSubmit();

    useEffect(() => {
        if (source) {
            updateGeometry(source);
        }
    }, []);

    const updateGeometry = (source) => {
        const features = source?.getFeatures();
        if (draftWorkpack && features && features.length > 0) {
            const aoi = features[0];
            const aoiGeometry = aoi?.getGeometry();
            const geoJsonGeometry = geometry?.toGeoJSON(aoiGeometry, 64, true);
            setDraftWorkpack(prevState => {
                return {
                    ...prevState,
                    geometry: geoJsonGeometry
                };
            });
        }
    };

    const handleOnPress = () => {
        const formData = jsonToFormData(draftWorkpack);
        submit(formData, {
            action: CREATE_WORKPACK_PAGE,
            method: 'PUT'
        });
    };

    return <div
        className={styles.tooltipWrapper}
        {...(drawType === LINE ? hoverProps : {})}
    >
        {drawType === LINE && mapMode.length > 1 && showTooltip &&
                    <Tooltip
                        isOpen={true}
                        data-testid="createPdf.tooltip"
                        className={styles.tooltip}
                        contentClassName={styles.tooltipContent}
                    >
                        <FormattedMessage id='bookmark.button.createWorkPack.tooltip' />
                    </Tooltip>
        }
        <Button data-testid="mapToolBar.workpack.continue"
            variant="success"
            isDisabled={drawType === LINE}
            onPress={handleOnPress}>
            <FormattedMessage id='continueWorkpackButton.text' />
        </Button>
    </div>;
};

export default ContinueWorkpackButton;
